import { call, put, takeLatest } from "redux-saga/effects";
import { API } from "../../../api/api";
import { mailingAPI } from "../api/api";
import { MailingActionTypes } from "../actions/actionTypes";
import { ToasterService } from "../../../services/toaster/toaster.service";

function* addMailingList(action) {
    try {
        const newMailingList = yield call(() =>
            mailingAPI.addMailingLists(action.payload)
        );

        yield put({
            type: MailingActionTypes.ADD_MAILING_LISTS_SUCCESS,
            payload: newMailingList.data
        });

        ToasterService.successToast("Mailing List created with success.");
    } catch (e) {
        API.handleError(e.response, "Error creating Mailing List.");

        yield put({
            type: MailingActionTypes.ADD_MAILING_LISTS_FAIL,
            message: e.message
        });
    }
}

export function* addMailingListWatcher() {
    yield takeLatest(MailingActionTypes.ADD_MAILING_LISTS, addMailingList);
}


function* editMailingList(action) {
    try {
       yield call(() =>
            mailingAPI.editMailingList(action.payload)
        );

        yield put({
            type: MailingActionTypes.EDIT_MAILING_LIST_SUCCESS
        });

        ToasterService.successToast("Mailing List saved with success.");
    } catch (e) {
        API.handleError(e.response, "Error saving Mailing List.");

        yield put({
            type: MailingActionTypes.EDIT_MAILING_LIST_FAIL,
            message: e.message
        });
    }
}

export function* editMailingListWatcher() {
    yield takeLatest(MailingActionTypes.EDIT_MAILING_LIST, editMailingList);
}

function* toggleMailingListActiveState(action) {
    try {
        let status;

        if (action.payload.active) {
            status = yield call(() => mailingAPI.activateMailingList(action.payload));
        } else {
            status = yield call(() => mailingAPI.deactivateMailingList(action.payload));
        }

        if (status.status == 200) {
            yield put({
                type: MailingActionTypes.TOGGLE_MAILING_LIST_ACTIVE_SUCCESS,
                payload: {
                    active: action.payload.active,
                    id: action.payload.mailingList.id
                }
            });

            ToasterService.successToast("Mailing List saved with success.");
        } else {
            ToasterService.errorToast("Error changing Mailing List status.");
        }

    } catch (e) {
        API.handleError(e.response, "Error changing Mailing List status.");

        yield put({
            type: MailingActionTypes.TOGGLE_MAILING_LIST_ACTIVE_FAIL,
            message: e.message
        });
    }
}

export function* toggleMailingListActiveStateWatcher() {
    yield takeLatest(MailingActionTypes.TOGGLE_MAILING_LIST_ACTIVE, toggleMailingListActiveState);
}
